import { SVGProps } from 'react';

const CircleArrowOutDownRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 22a10 10 0 1 1 10-10m0 10L12 12m4 10h6v-6"
    />
  </svg>
);
export default CircleArrowOutDownRight;
